import {iosTransitionAnimation, Animation} from '@ionic/core';

export const navAnimation = (navEl, opts): Animation => iosTransitionAnimation(navEl, opts);
